import { formatIsoDateToLocale } from "@pulse-ui/formatting";

const DateDisplayInput = ({
  name,
  value,
  label,
}: {
  name: string;
  value: string;
  label: string;
}) => {
  return (
    <div className="pulse-default-text-input pulse-br-sm pulse-mb-2 pulse-col-xs-6 pulse-col-sm-6 pulse-col-md-6 pulse-col-lg-6 pulse-col-xl-6">
      <p
        className={`pulse-color--background-50
                pulse-typography-body-2 pulse-mb-1 pulse-default-text-input-label`}
      >
        {label}
      </p>
      <div className="input-icon-container">
        <input
          className={`input-field pulse-bg-color--background-800 pulse-typography-body-2`}
          name={name}
          value={formatIsoDateToLocale(value)}
          type="text"
          disabled
          style={{ color: "#939db6" }}
        />
      </div>
    </div>
  );
};

export default DateDisplayInput;
